import { browserTracingIntegration, init } from '@sentry/browser';
import { AppConfig } from 'pmn/types';

export const initSentry = ({ SENTRY_CLIENT_DSN, SENTRY_ENABLED }: AppConfig): void => {
  if (!SENTRY_ENABLED) {
    return;
  }

  init({
    dsn: SENTRY_CLIENT_DSN,

    denyUrls: [
      // Facebook blocked
      /graph\.facebook\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      /extensions\//i,
      /^chrome:\/\//i,
      /onloadwff\.js/,
    ],
    beforeSend(event) {
      if (event.request && event.request.url && event.request.url.indexOf('worker.js') > -1) {
        return null;
      }

      return event;
    },
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 0.3,
  });
};
